import styled from '@emotion/styled';

export const List = styled.ul`
  display: flex;
  flex-wrap: wrap;
  row-gap: 16px;
  column-gap: 12px;
`;

export const Item = styled.li``;
